<template>
  <div class="row">
    <div class="d-flex d-inline">
      <div>
        <input
          type="text"
          class="form-control mt-2 custom-input"
          readonly
          v-model="text"
        />
      </div>
      <div>
        <button
          type="button"
          class="btn btn-copy text-success font-weight-bold"
          @click="copyText()"
          style="height: 38px"
        >
          <i :class="copied"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CopyButton",
  props: ["text"],
  data() {
    return {
      copied: "far fa-copy fa-1x",
    };
  },
  methods: {
    copyText() {
      const self = this;
      if (navigator) {
        navigator.clipboard.writeText(this.text);
      }
      self.copied = "fa fa-check";
      this.$toast.success(this.$t("copySuccess"));
      let i = setInterval(() => {
        self.copied = "far fa-copy fa-1x";
        clearInterval(i);
      }, 1000);
    },
  },
};
</script>

<style scoped>
.custom-input {
  border: dashed green 0.5px;
  max-width: 100%;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}
</style>
